import { LoadStatus } from '../../Types';
import type { PaymentsActionTypes } from './actions';
import { PaymentsActions } from './actions';
import type { PaymentsState } from './Types/PaymentsState';

export const initialState: PaymentsState = {
    properties: {
        loadStatus: LoadStatus.INITIAL_STATE,
        sortOrder: [],
    },
};

export function paymentsReducer(state: PaymentsState = initialState, action: PaymentsActionTypes): PaymentsState {
    switch (action.type) {
        case PaymentsActions.LOAD_PAYMENTS_PROPERTIES:
            return {
                ...state,
                properties: {
                    loadStatus: LoadStatus.PENDING,
                },
            };
        case PaymentsActions.SET_PAYMENTS_PROPERTIES:
            return {
                ...state,
                properties: {
                    loadStatus: LoadStatus.LOADED,
                    ...action.payload.reduce(
                        (agg, curr) => ({
                            ...agg,
                            [curr.id]: curr,
                        }),
                        {},
                    ),
                    sortOrder: action.payload.map((property) => property.id),
                },
            };
        case PaymentsActions.SET_PAYMENTS_PROPERTIES_ERROR_STATE:
            return {
                ...state,
                properties: {
                    loadStatus: LoadStatus.ERROR,
                    errorState: action.payload.secondaryMessage
                        ? {
                              error: action.payload.errorMessage,
                              secondaryMessage: action.payload.secondaryMessage,
                          }
                        : { error: action.payload.errorMessage },
                    sortOrder: [],
                },
            };
        default:
            return state;
    }
}
